module.exports = __webpack_public_path__ + "img/unread.d3d53f9f.svg";